import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { getOrderStatus } from '../../services/userService';
import DashboardFeatureCard from './DashboardFeatureCard';
import { dashboardCards } from './dashboardCards';

const Dashboard: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [orderStatus, setOrderStatus] = useState<{ status: string; message?: string } | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const orderId = searchParams.get('od');
    if (orderId) {
      const checkOrderStatus = async () => {
        try {
          setIsLoading(true);
          const status = await getOrderStatus(orderId);
          console.log(status, 'status123')
          setOrderStatus(status);

          setTimeout(() => {
            setOrderStatus(null);
          }, 5000);
        } catch (error) {
          console.error('Failed to check order status:', error);
          setOrderStatus({ status: 'error', message: 'Failed to check order status' });

          setTimeout(() => {
            setOrderStatus(null);
          }, 5000);
        } finally {
          setIsLoading(false);
        }
      };
      checkOrderStatus();
    }
  }, [searchParams]);

  return (
    <div className="min-h-[80vh] bg-white">
      <div className="w-full px-4 pt-2 pb-6">
        {orderStatus && (
          <div className={`mb-8 p-6 rounded-2xl shadow-lg transition-all duration-500 transform ${orderStatus.status === 'paid' || orderStatus.status === 'completed'
            ? 'bg-gradient-to-r from-green-100 to-green-200 text-green-800 border-l-4 border-green-500'
            : orderStatus.status === 'failed' || orderStatus.status === 'error'
              ? 'bg-gradient-to-r from-red-100 to-red-200 text-red-800 border-l-4 border-red-500'
              : 'bg-gradient-to-r from-yellow-100 to-yellow-200 text-yellow-800 border-l-4 border-yellow-500'
            }`}>
            <div className="flex items-center justify-center space-x-3">
              {isLoading ? (
                <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-current"></div>
              ) : (
                <div className={`w-3 h-3 rounded-full ${orderStatus.status === 'paid' || orderStatus.status === 'completed' ? 'bg-green-500' :
                  orderStatus.status === 'failed' || orderStatus.status === 'error' ? 'bg-red-500' : 'bg-yellow-500'
                  }`}></div>
              )}
              <p className="text-lg font-medium">
                {isLoading ? "Checking order status..." : (orderStatus.message || `Payment status: ${orderStatus.status}`)}
              </p>
            </div>
          </div>
        )}

        <div className="flex flex-wrap gap-3 lg:gap-4">
          {dashboardCards.map((card) => (
            <DashboardFeatureCard
              key={card.id}
              to={card.to}
              title={card.title}
              description={card.description}
              beforeImage={card.beforeImage}
              afterImage={card.afterImage}
              tool={card.tool}
              variant={card.variant}
              reelsImage={card.reelsImage}
              reelsVideo={card.reelsVideo}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
